import React, { Component } from 'react';
import { Tabs } from 'antd';

import ChannelForm from './components/ChannelForm/ChannelForm';
import AdLinkManagementPane from './scenes/AdLinkManagementPane/AdLinkManagementPane';
import ChannelInsight from './components/ChannelInsight/ChannelInsight';
import './ChannelManagementPage.scss';

const TabPane = Tabs.TabPane;

export class ChannelManagementPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: 'detail'
        };
    }

    componentDidMount() {
        const { location } = this.props;
        const { hash } = location;

        if (hash) {
            this.setState({ activeTab: hash.substring(1) })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { location } = this.props;
        const { hash } = location;

        if (hash !== prevProps.location.hash)
            this.setState({ activeTab: hash.substring(1) })
    }

    render() {
        const { location, history, match } = this.props;
        const { activeTab } = this.state;
        const isCreateNewChannel = match.params.channelId === undefined;

        return (
            <div className="ManagementPage">
                <h2>{isCreateNewChannel ? 'Create New Channel' : 'Edit Channel'}</h2>
                <Tabs 
                    activeKey={activeTab}
                    type="card" 
                    tabBarGutter={5}
                    onChange={(key) => history.push(`${location.pathname}#${key}`)}
                >
                    <TabPane tab="Detail" key="detail">
                        <ChannelForm/>
                    </TabPane>
                    {
                        !isCreateNewChannel &&
                        <TabPane tab="Ad Link" key="adlink">
                            <AdLinkManagementPane channelId={match.params.channelId}/>
                        </TabPane>
                    }
                    {
                        !isCreateNewChannel &&
                        <TabPane tab="Insight" key="insight">
                            <ChannelInsight/>
                        </TabPane>
                    }
                </Tabs>
            </div>
        );
    }
}

export default ChannelManagementPage;


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ChannelManagementPage/ChannelManagementPage.js